import { UserRole } from '../types';

// Yetki kontrolü için utility fonksiyonları
export const canAddProduct = (userRole: UserRole): boolean => {
  // Ürün ekleme yetkisi: admin, warehouse, manager
  return ['admin', 'warehouse', 'manager'].includes(userRole);
};

export const canEditProduct = (userRole: UserRole): boolean => {
  // Ürün düzenleme yetkisi: admin, warehouse, manager
  return ['admin', 'warehouse', 'manager'].includes(userRole);
};

export const canDeleteProduct = (userRole: UserRole): boolean => {
  // Ürün silme yetkisi: sadece admin
  return userRole === 'admin';
};

export const canAddWarehouse = (userRole: UserRole): boolean => {
  // Depo ekleme yetkisi: admin, manager
  return ['admin', 'manager'].includes(userRole);
};

export const canEditWarehouse = (userRole: UserRole): boolean => {
  // Depo düzenleme yetkisi: admin, manager, warehouse
  return ['admin', 'manager', 'warehouse'].includes(userRole);
};

export const canDeleteWarehouse = (userRole: UserRole): boolean => {
  // Depo silme yetkisi: sadece admin
  return userRole === 'admin';
};

export const canAddCustomer = (userRole: UserRole): boolean => {
  // Müşteri ekleme yetkisi: admin, manager, salesperson
  return ['admin', 'manager', 'salesperson'].includes(userRole);
};

export const canEditCustomer = (userRole: UserRole): boolean => {
  // Müşteri düzenleme yetkisi: admin, manager, salesperson
  return ['admin', 'manager', 'salesperson'].includes(userRole);
};

export const canDeleteCustomer = (userRole: UserRole): boolean => {
  // Müşteri silme yetkisi: admin, manager
  return ['admin', 'manager'].includes(userRole);
};

export const canCreateOrder = (userRole: UserRole): boolean => {
  // Sipariş oluşturma yetkisi: admin, manager, salesperson
  return ['admin', 'manager', 'salesperson'].includes(userRole);
};

export const canApproveOrder = (userRole: UserRole): boolean => {
  // Sipariş onaylama yetkisi: admin, manager
  return ['admin', 'manager'].includes(userRole);
};

export const canPrepareOrder = (userRole: UserRole): boolean => {
  // Sipariş hazırlama yetkisi: admin, warehouse
  return ['admin', 'warehouse'].includes(userRole);
};

export const canDeliverOrder = (userRole: UserRole): boolean => {
  // Sipariş teslim yetkisi: admin, driver
  return ['admin', 'driver'].includes(userRole);
};

export const canViewAnalytics = (userRole: UserRole): boolean => {
  // Analitik görüntüleme yetkisi: admin, manager
  return ['admin', 'manager'].includes(userRole);
};

export const canManageUsers = (userRole: UserRole): boolean => {
  // Kullanıcı yönetimi yetkisi: sadece admin
  return userRole === 'admin';
};

export const canManageSettings = (userRole: UserRole): boolean => {
  // Ayar yönetimi yetkisi: sadece admin
  return userRole === 'admin';
};

// Rol açıklamaları
export const getRoleDescription = (role: UserRole): string => {
  const descriptions = {
    admin: 'Sistem Yöneticisi - Tüm yetkilere sahip',
    manager: 'Müdür - Yönetim ve onay yetkileri',
    warehouse: 'Depo Sorumlusu - Stok ve depo yönetimi',
    salesperson: 'Satış Temsilcisi - Müşteri ve sipariş yönetimi',
    driver: 'Sürücü - Teslimat yönetimi'
  };
  return descriptions[role] || 'Bilinmeyen rol';
};

// Rol hiyerarşisi
export const getRoleHierarchy = (role: UserRole): number => {
  const hierarchy = {
    admin: 5,
    manager: 4,
    warehouse: 3,
    salesperson: 2,
    driver: 1
  };
  return hierarchy[role] || 0;
};

// Rol yetki matrisi
export const rolePermissions = {
  admin: {
    products: { create: true, read: true, update: true, delete: true },
    warehouses: { create: true, read: true, update: true, delete: true },
    customers: { create: true, read: true, update: true, delete: true },
    orders: { create: true, read: true, update: true, delete: true, approve: true },
    analytics: { read: true },
    users: { create: true, read: true, update: true, delete: true },
    settings: { read: true, update: true }
  },
  manager: {
    products: { create: true, read: true, update: true, delete: false },
    warehouses: { create: true, read: true, update: true, delete: false },
    customers: { create: true, read: true, update: true, delete: true },
    orders: { create: true, read: true, update: true, delete: false, approve: true },
    analytics: { read: true },
    users: { create: false, read: true, update: false, delete: false },
    settings: { read: true, update: false }
  },
  warehouse: {
    products: { create: true, read: true, update: true, delete: false },
    warehouses: { create: false, read: true, update: true, delete: false },
    customers: { create: false, read: true, update: false, delete: false },
    orders: { create: false, read: true, update: true, delete: false, approve: false },
    analytics: { read: false },
    users: { create: false, read: false, update: false, delete: false },
    settings: { read: false, update: false }
  },
  salesperson: {
    products: { create: false, read: true, update: false, delete: false },
    warehouses: { create: false, read: true, update: false, delete: false },
    customers: { create: true, read: true, update: true, delete: false },
    orders: { create: true, read: true, update: false, delete: false, approve: false },
    analytics: { read: false },
    users: { create: false, read: false, update: false, delete: false },
    settings: { read: false, update: false }
  },
  driver: {
    products: { create: false, read: true, update: false, delete: false },
    warehouses: { create: false, read: true, update: false, delete: false },
    customers: { create: false, read: true, update: false, delete: false },
    orders: { create: false, read: true, update: true, delete: false, approve: false },
    analytics: { read: false },
    users: { create: false, read: false, update: false, delete: false },
    settings: { read: false, update: false }
  }
}; 